import type { FramePayload, MetadataPayload } from '../studio-store/types';
import type { AnnotationFramesRecord } from '../types/annotation';
export const EMPTY_FRAME_MAP = Object.freeze(new Map<string, FramePayload>());

// A stable empty Map used as the default value for annotation frames.
// Must be a module-level constant so that all atom reads return the same reference
// when no data is loaded. Returning a new Map() each time would cause Jotai to
// see a changed value on every evaluation, triggering unnecessary re-renders in
// all consumers even when no annotation data has changed.
export const EMPTY_FRAMES: AnnotationFramesRecord = (Object.freeze(new Map()) as AnnotationFramesRecord);
export const EMPTY_METADATA_MAP = Object.freeze(new Map<string, MetadataPayload>());